<ef-loading-container
    [observables]="[settings$, categories$, daysOfWeek$, payrollFrequency$]"
></ef-loading-container>
<ef-process-detail [process]="process$ | async"></ef-process-detail>
<ef-company-setting-presenter
    [settings]="settings$ | async"
    [categories]="categories$ | async"
    [daysOfWeek]="daysOfWeek$ | async"
    [payrollFrequency]="payrollFrequency$ | async"
    [selectedError]="selectedErrorWithStatus$ | async"
    (Save)="onSave($event)"
    (ShowError)="onShowError($event)"
></ef-company-setting-presenter>
